import { Directive, inject } from "@angular/core";
import { PopoverController } from "@ionic/angular/standalone";

import { BaseComponent } from "@mp/common/base/base.component";

@Directive()
export abstract class BasePopoverComponent<V = null | unknown> extends BaseComponent {
    protected popoverCtrl: PopoverController;

    protected constructor() {
        super();
        this.popoverCtrl = inject(PopoverController);
    }

    public closePopover(data?: V): void {
        this.log.debug("Closing popover");
        this.popoverCtrl.dismiss(data).catch(err => this.log.warn("Error on dismiss popover", err));
    }
}
